module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-9-sample06-2d2cd413a724b4250107d2a9052cab8e.jpg";